function SiteContainer( props: any ) {
    return (
        <div
    style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        overflow: "auto",
    }}
>
                {props.children}
        </div>
    )
}
export default SiteContainer;